import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
var _class, _descriptor;
import { action, computed } from 'mobx';
import api from 'core/util/api';
import { modelFinder } from 'app/stores/util/modelFinder';
import SiteModel from './SiteModel';
import SiteCollection from './SiteCollection';
export let SiteStore = (_class = class SiteStore {
  constructor() {
    this.collection = new SiteCollection();
    this.history = void 0;
    this.navigateToSite = siteId => {
      this.history?.push(`/v4/core/quick-views/sites/${siteId}`);
    };
    this.createSite = (siteAttributes, options) => {
      const site = this.collection.build(undefined, {
        select: true
      });
      return site.save(siteAttributes, options);
    };
    _initializerDefineProperty(this, "fetchSite", _descriptor, this);
    this.getSiteOption = model => ({
      id: model.id,
      value: model.id,
      label: model.get('title'),
      activeDevices: model.get('active_device_count'),
      numDevices: model.get('device_count'),
      hasCloudDevices: model.hasCloudDevices
    });
    this.exportPdf = (search = '') => {
      const date = new Date().toISOString().slice(0, 10).replace(/-/g, '');
      import('app/stores/$exports').then(({
        default: $exports
      }) => $exports.fetchExport({
        path: '/api/ui/export/exportPage',
        type: 'pdf',
        fileName: `export-sites-${date}`,
        exportOptions: {
          location: `/v4/export/settings/sites${search}`
        }
      }));
    };
    this.exportCsv = data => {
      const path = '/api/ui/sites/csv';
      const date = new Date().toISOString().slice(0, 10).replace(/-/g, '');
      const fileName = `export-sites-${date}`;
      const type = 'csv';
      const options = {
        path,
        fileName,
        type
      };
      import('app/stores/$exports').then(({
        default: $exports
      }) => {
        $exports.addLoadingExport(options);
        return api.post(path, {
          data,
          rawResponse: true
        }).then(response => {
          $exports.clearLoadingExport(options);
          $exports.addPayload(response.text, options);
        });
      });
    };
    /**
     * Must be called when making a change to devices - Device-Site membership is now calculated on the backend.
     */
    this.refreshSites = async () => this.collection.fetch({
      force: true,
      preserveSelection: true
    }).then(() => {}).catch(error => {
      console.error('Failed to refresh sites after device change', error);
    });
  }
  // actually react-router history object

  initialize() {
    setTimeout(() => this.collection.fetch(), 0);
  }
  /**
   * This is only private to make test mocks easier.
   */
  get _byName() {
    return modelFinder(this.collection, 'title');
  }
  byName(name) {
    return this._byName(name);
  }
  get noSitesConfigured() {
    return this.collection.unfilteredSize === 0;
  }
  get numSites() {
    return this.collection.unfilteredSize;
  }
  get siteOptions() {
    if (!this.collection.hasFetched) {
      return [];
    }
    return this.collection.map(this.getSiteOption).sort((a, b) => (a.label || '').localeCompare(b.label || ''));
  }
  get siteOptionsMap() {
    const hashMap = {};
    this.collection.models.forEach(model => {
      hashMap[model.id] = this.getSiteOption(model);
    });
    return hashMap;
  }

  // Some customers have a lot of devices. If you only need labels then this map will be much faster
  get siteLabelsMap() {
    const hashMap = {};
    this.collection.models.forEach(model => {
      hashMap[model.id] = {
        id: model.id,
        value: model.id,
        label: model.get('title')
      };
    });
    return hashMap;
  }
  get siteTitleOptions() {
    if (!this.collection.hasFetched) {
      return [];
    }
    return this.collection.map(site => ({
      id: site.id,
      value: site.get('title'),
      label: site.get('title')
    }));
  }
  get sitesGeoMap() {
    return this.collection.reduce((acc, model) => {
      const {
        id,
        lat,
        lon,
        city,
        country,
        region
      } = model.get();
      acc[id] = {
        city: {
          latitude: lat,
          longitude: lon,
          name: city
        },
        country: {
          code: country,
          name: model.countryName
        },
        region: {
          name: region
        }
      };
      return acc;
    }, {});
  }
  get sitesTitleMap() {
    return this.collection.reduce((acc, model) => {
      const {
        id,
        title
      } = model.get();
      if (title) {
        acc[title] = id;
      }
      return acc;
    }, {});
  }
}, _applyDecoratedDescriptor(_class.prototype, "_byName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "_byName"), _class.prototype), _descriptor = _applyDecoratedDescriptor(_class.prototype, "fetchSite", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return siteId => {
      const site = new SiteModel({
        id: siteId
      });
      return site.fetch().then(() => site);
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "noSitesConfigured", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "noSitesConfigured"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "numSites", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "numSites"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "siteOptions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "siteOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "siteOptionsMap", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "siteOptionsMap"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "siteLabelsMap", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "siteLabelsMap"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "siteTitleOptions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "siteTitleOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sitesGeoMap", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "sitesGeoMap"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sitesTitleMap", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "sitesTitleMap"), _class.prototype), _class);
const $sites = new SiteStore();
export default $sites;